module.exports = __webpack_public_path__ + "media/mario.7a1678d8.wav";